module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#environment",
      toString: function () {
        return this.url;
      }
    }